import React from 'react';

const JobCreationSidebar = ({ machines, timeLimit, onTimeLimitChange, onDragStart, onQuickCreate }) => {
  const nodeTemplates = [
    {
      id: 'dispatcher-template',
      name: '📋 Job Dispatcher',
      type: 'dispatcher',
      description: 'Central job distribution hub',
      icon: '📋'
    },
    {
      id: 'cnc-machine',
      name: '🔧 CNC Machine',
      type: 'machine',
      description: 'CNC milling & drilling optimizer',
      icon: '🔧'
    },
    {
      id: 'robot-machine',
      name: '🤖 Robotic Cell', 
      type: 'machine',
      description: 'Robotic assembly optimizer',
      icon: '🤖'
    },
    {
      id: 'laser-machine',
      name: '⚡ Laser Cutter',
      type: 'machine', 
      description: 'Laser cutting optimizer',
      icon: '⚡'
    },
    {
      id: 'printer-machine',
      name: '🖨️ 3D Printer',
      type: 'machine',
      description: '3D printing scheduler',
      icon: '🖨️'
    }
  ];

  const optimizationAlgorithms = [
    { name: 'Genetic Algorithm', efficiency: '92%', icon: '🧬' },
    { name: 'Simulated Annealing', efficiency: '87%', icon: '🔥' },
    { name: 'Ant Colony', efficiency: '85%', icon: '🐜' },
    { name: 'Round Robin', efficiency: '78%', icon: '🔄' },
    { name: 'FIFO', efficiency: '65%', icon: '⏭️' }
  ];

  return (
    <div className="workflow-sidebar optimization-sidebar">
      <div className="sidebar-header">
        <h3>🎯 Optimization Canvas</h3>
        <p>Drag components to build your scheduling system</p>
      </div>

      <div className="sidebar-section">
        <h4>System Components</h4>
        <div className="template-grid">
          {nodeTemplates.map((template) => (
            <div
              key={template.id}
              className="template-item optimization-template"
              draggable
              onDragStart={(event) => onDragStart(event, template.type)}
            >
              <div className="template-icon">{template.icon}</div>
              <div className="template-info">
                <div className="template-name">{template.name}</div>
                <div className="template-desc">{template.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="sidebar-section">
        <h4>Active Machines</h4>
        <div className="machine-list optimization-machines">
          {machines.map((machine) => (
            <div key={machine.id} className={`machine-item optimization-machine ${machine.status}`}>
              <div className="machine-info">
                <div className="machine-header">
                  <span className="machine-name">
                    {machine.type === 'CNC_MILL' ? '🔧' : 
                     machine.type === 'ROBOTIC_ARM' ? '🤖' : 
                     machine.type === 'LASER_CUTTER' ? '⚡' : '⚙️'} {machine.name}
                  </span>
                  <span className={`optimization-status ${machine.status}`}>
                    {machine.status === 'optimizing' ? '🧠' : 
                     machine.status === 'idle' ? '✅' : 
                     machine.status === 'scheduled' ? '📅' : '⚙️'}
                  </span>
                </div>
                <div className="machine-metrics">
                  <div className="metric">
                    <span className="metric-label">Jobs:</span>
                    <span className="metric-value">{machine.pending_jobs || 0}P / {machine.scheduled_jobs || 0}S</span>
                  </div>
                  <div className="metric">
                    <span className="metric-label">Efficiency:</span>
                    <span className="metric-value">{machine.efficiency || 85}%</span>
                  </div>
                  <div className="metric">
                    <span className="metric-label">Algorithm:</span>
                    <span className="metric-algorithm">{machine.optimization_algorithm || 'Round Robin'}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="sidebar-section">
        <h4>Optimization Algorithms</h4>
        <div className="algorithm-list">
          {optimizationAlgorithms.map((algo, index) => (
            <div key={index} className="algorithm-item">
              <span className="algo-icon">{algo.icon}</span>
              <div className="algo-info">
                <div className="algo-name">{algo.name}</div>
                <div className="algo-efficiency">Avg. Efficiency: {algo.efficiency}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="sidebar-section">
        <h4>Optimization Settings</h4>
        <div className="setting-group">
          <label className="setting-label">Time Limit (seconds):</label>
          <input 
            type="number" 
            min="10" 
            max="300" 
            value={timeLimit || 30}
            className="setting-input no-arrows"
            onChange={(e) => {
              const newTimeLimit = parseInt(e.target.value) || 30;
              if (onTimeLimitChange) {
                onTimeLimitChange(newTimeLimit);
              }
            }}
          />
        </div>
      </div>

      <div className="sidebar-section">
        <h4>System Actions</h4>
        <button className="quick-action-btn optimization-btn" onClick={onQuickCreate}>
          🚀 Run Global Optimization
        </button>
        <button className="quick-action-btn" onClick={() => window.location.reload()}>
          🔄 Refresh System Status
        </button>
        <button className="quick-action-btn">
          📊 View Analytics Dashboard
        </button>
      </div>
    </div>
  );
};

export default JobCreationSidebar;
